// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"3dde8ec5","186":"c44e0072","225":"ae38897f","344":"0115f8fd","372":"c2cd8a8e","377":"528fc032","443":"caf441e2","738":"a068ab76","841":"75991df1","856":"65d40f9a","886":"9bfb4db8"}[chunkId] + ".chunk.js";
};